export enum WindowsDoorsPropertyName {
  WindowsDoorsCategory = 'category',
  Opening = 'opening',
  FrameMaterial = 'frame_material',
  Glazing = 'glazing',
  FireRated = 'fire_rated',
  WindowsDoorsType = 'type',
}

export enum WindowsDoorsCategory {
  Window = 'Window',
  DoorExternal = 'Door, external',
  DoorInternal = 'Door, internal',
  GlassGoods = 'Glass goods',
}

export enum Opening {
  SideHung = 'Side hung',
  Inward = 'Inward',
  FullyReversable = 'Fully reversable',
  Fixed = 'Fixed',
}

export enum FrameMaterial {
  Aluminum = 'Aluminum',
  WoodAluminum = 'Wood, aluminum',
  Wood = 'Wood',
  WoodLaminated = 'Wood (laminated)',
  SteelStainless = 'Steel (stainless)',
  SteelCarbon = 'Steel (carbon)',
}

export enum FireRated {
  False = 'false',
  True = 'true',
}

export enum Glazing {
  Full = 'Full',
  Semi = 'Semi',
  None = 'None',
}

export enum WindowsDoorsType {
  FloatGlass = 'Float glass',
  FireResistent = 'Fire-resistent',
  InsulatingDouble = 'Insulating, double',
  InsulatingTripple = 'Insulating, tripple',
  SafetyLaminated = 'Safety, laminated',
  SafetyToughened = 'Safety, toughened',
}

export enum WindowsDoorsProducts {
  SideHungWoodAluminum = 'boverket_sv-SE_6000000103',
  SideHungWood = 'boverket_sv-SE_6000000104',
  InwardWoodAluminum = 'boverket_sv-SE_6000000106',
  InwardWood = 'boverket_sv-SE_6000000105',
  FullyReversableWoodAluminum = 'boverket_sv-SE_6000000108',
  FullyReversableWood = 'boverket_sv-SE_6000000107',
  FixedWoodAluminum = 'boverket_sv-SE_6000000110',
  FixedWood = 'boverket_sv-SE_6000000109',
  WindowAluminumTripleGlazed = 'boverket_sv-SE_6000000225',
  DoorExternalFullGlazingWoodAluminum = 'boverket_sv-SE_6000000114',
  DoorExternalFullGlazingWood = 'boverket_sv-SE_6000000113',
  DoorExternalFullGlazingAluminum = 'boverket_sv-SE_6000000187',
  DoorExternalSemiGlazingWoodAluminum = 'boverket_sv-SE_6000000112',
  DoorExternalSemiGlazingWood = 'boverket_sv-SE_6000000111',
  DoorExternalWood = 'boverket_sv-SE_6000000118',
  DoorExternalSteelStainless = 'boverket_sv-SE_6000000116',
  DoorExternalSteelCarbon = 'boverket_sv-SE_6000000115',
  DoorInternalFireRatedWood = 'boverket_sv-SE_6000000119',
  DoorInternalFireRatedWoodLaminated = 'boverket_sv-SE_6000000120',
  DoorInternalFireRatedSteelCarbon = 'boverket_sv-SE_6000000117',
  DoorInternalWood = 'boverket_sv-SE_6000000121',
  GlassGoodsFloatGlass = 'boverket_sv-SE_6000000122',
  GlassGoodsFireResistent = 'boverket_sv-SE_6000000179',
  GlassGoodsInsulatingDouble = 'boverket_sv-SE_6000000175',
  GlassGoodsInsulatingTripple = 'boverket_sv-SE_6000000176',
  GlassGoodsSafetyLaminated = 'boverket_sv-SE_6000000177',
  GlassGoodsSafetyToughened = 'boverket_sv-SE_6000000178',
}
